import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../../../../../modules/src/lib/core/services/menu.service';

@Component({
  selector: 'app-account-header',
  templateUrl: './account-header.component.html',
  styleUrls: ['./account-header.component.scss'],
  standalone: false,
})
export class AccountHeaderComponent implements OnInit {
  constructor(public menuService: MenuService) {
  }

  ngOnInit(): void {
  }

}
